import type { StoryType } from "@/config";

export const handleFetch = async (
  url: string,
): Promise<[StoryType | null, unknown]> => {
  try {
    const response = await fetch(url, { cache: "force-cache" });
    const data = await response.json();
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
